const HASH_PLACEHOLDER = '__HASH__'

/** 跳转 appFrame 前：url 参数中的 # 替换为占位符并编码 */
export function formatAppFrameLinkUrl(url) {
  return encodeURIComponent(String(url).replace(/#/g, HASH_PLACEHOLDER))
}

/** appFrame 页面解析 iframe 前：占位符还原为 # */
export function parseAppFrameLinkUrl(raw) {
  let url = raw
  try {
    url = raw.includes('%') ? decodeURIComponent(raw) : raw
  } catch (e) {
    url = raw
  }
  return String(url).replace(new RegExp(HASH_PLACEHOLDER, 'g'), '#')
}

/** 无协议域名补 https://，避免 www.baidu.com 过不了校验、被当成相对路径 */
export function ensureAbsoluteHttpUrl(raw) {
  const url = String(raw || '').trim()
  if (!url) return ''
  if (/^https?:\/\//i.test(url)) return url
  if (url.startsWith('//')) return 'https:' + url
  if (/^[\w.-]+\.[a-z]{2,}/i.test(url)) return 'https://' + url
  return url
}

/** 修正已拼接好的 appFrame 跳转地址 */
export function fixAppFrameHref(href) {
  if (!String(href).includes('/appFrame')) return href
  return String(href).replace(/([?&]url=)([^&]*)/, (_, prefix, val) => {
    let decoded = val
    try {
      decoded = decodeURIComponent(val)
    } catch (e) {}
    if (!decoded.includes('#')) return prefix + val
    return prefix + formatAppFrameLinkUrl(decoded)
  })
}
